import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormFooter from '../../../components/form-footer';
import IntakeBusinessDueDiligenceDetailsFields from '../../../components/intake/business-due-diligence/details-fields';
import BusinessDueDiligenceDetailsSchema from '../../../validation-schemas/business-due-diligence-details-schema';
import { updateActiveFormBusinessDueDiligenceDetails, selectActiveFormBusinessDueDiligenceDetails } from '../../../reducers/active-form-slice';
import FormHeaderButtons from '../form-header-buttons';
import { hasNonBlankValues } from '../../../utility/has-values';

const IntakeBusinessDueDiligenceDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    /**
     * get current form values
     */
    const businessDueDiligenceDetails = useSelector(selectActiveFormBusinessDueDiligenceDetails);
    const hasValues = hasNonBlankValues(businessDueDiligenceDetails);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/");
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateActiveFormBusinessDueDiligenceDetails(values));
        navigate("/intake/additional-information");
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateActiveFormBusinessDueDiligenceDetails(values));
    };


    /**
     * setup the initial values
     */
    const initialValues = {
        businessName: '',
        ownersName: '',
        businessAddress: '',
        businessAddress2: '',
        city: '',
        stateProvince: '',
        zip: '',
        country: '',
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? businessDueDiligenceDetails : initialValues}
                validationSchema={BusinessDueDiligenceDetailsSchema.fields.businessDueDiligenceDetails}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Business Due Diligence Details</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>

                        <IntakeBusinessDueDiligenceDetailsFields
                            errors={errors}
                            touched={touched}
                            values={values}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`50`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeBusinessDueDiligenceDetails;